export default __webpack_public_path__ + "static/media/warning.757590ac.jpg";